import React, { useMemo } from "react";
import { seededBars } from "../lib/waveform";

export function Waveform({ id, progress = 0.35, height = 26 }) {
  const bars = useMemo(() => seededBars(id), [id]);
  const cutoff = Math.floor(bars.length * progress);
  return (
    <div className="waveform" style={{ height }}>
      {bars.map((h, i) => (
        <span key={`${id}-bar-${i}`} className={i < cutoff ? "on" : ""} style={{ height: `${h}px` }} />
      ))}
    </div>
  );
}
